module.exports = __webpack_public_path__ + "img/trouble-arrow.dd44b44b.svg";